import React, { useEffect, useRef, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";
import moment from 'moment';


import { useDispatch, useSelector } from "react-redux";
import Button from './Button';
import Input from './Input';
import Radios from './Radios';
import Checkbox from './Checkbox';
import Profiles from './Profiles';
import { close, loadingflas, open, listupdater } from '../redux/popupSlice';
import Select from './Select';
import AddrSelector from './AddrSelector';
import * as APIS from "../utils/service";
import { getMemberinfo,  } from "../utils/utils";


import { Map, DrawingManager, Polygon } from "react-kakao-maps-sdk"
import InputDate from './InputDate';

const { kakao } = window;

export default function CustomerOutWrite(props) {

    const {
        setcustomerwirte=() => {},
        setdetailwrite=() => {},
        uidx=null,
        setupdatestatus=() => {},
        row={},
        setselltypeproduct=() => {},
        setcategory_1product=() => {},
        setcategory_2product=() => {},       
        stypes=''        
    } = props;

    const managerRef = useRef(null)
    const { configdata } = useSelector(s => s.configReducer);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [errmsg, seterrmsg] = useState('');   

    const [sell_type, setsell_type] = useState('매매');   
    const [dateerrmsg, setdateerrmsg] = useState('');   

    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx}
    })
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return {labels: x?.title, values: x?.idx, category_1: x?.category_1}
    })
    //console.log(category_2_setting);
    const [category_1_OptionConsts, setcategory_1_OptionConsts] = useState(category_1_setting);   
    const [category_2_OptionConsts, setcategory_2_OptionConsts] = useState(category_2_setting);   
    
    
    const [cityspopflag, setcityspopflag] = useState(false);   
    const [polygonpopflag, setpolygonpopflag] = useState(false);   
    
    const [checkvalues, setcheckvalues] = useState([]);   
    const [polystatus, setpolystatus] = useState(false);   
    const [polydrawstatus, setpolydrawstatus] = useState(false);   

    let firstCategorys = configdata?.consts?.category_1_OptionConsts?.find((x, i) => i === 0)?.idx;
    const [category_1, setcategory_1] = useState(firstCategorys);   
    const [category_2, setcategory_2] = useState(configdata?.consts?.category_2_OptionConsts?.find((x, i) => (x?.category_1 === firstCategorys && i === 0))?.idx); 
    const [title, settitle] = useState(''); //고객명칭

    const [price_all_min, setprice_all_min] = useState(''); //보증금or거래가격 최소
    const [price_all_max, setprice_all_max] = useState(''); //보증금or거래가격 최대
    const [price_month_min, setprice_month_min] = useState(''); //월세 최소
    const [price_month_max, setprice_month_max] = useState(''); //월세 최대
    const [price_key_min, setprice_key_min] = useState(''); //권리금 최소
    const [price_key_max, setprice_key_max] = useState(''); //권리금 최대
    const [price_real, setprice_real] = useState(''); //실 투자금
    const [item_floor_min, setitem_floor_min] = useState(''); //희망층수 최소(지하는 -1 ~)
    const [item_floor_max, setitem_floor_max] = useState(''); //희망층수 최대
    const [item_area_min, setitem_area_min] = useState(''); //희망면적 최소
    const [item_area_max, setitem_area_max] = useState(''); //희망면적 최대
    const [item_year_min, setitem_year_min] = useState(''); //희망연식 최소 (YYYY)
    const [item_year_max, setitem_year_max] = useState(''); //희망연식 최댜 (YYYY)
    const [in_year, setin_year] = useState(''); //입주시기
    const [in_year_option1, setin_year_option1] = useState(false); //협의가능 true,false,
    const [in_year_option2, sestin_year_option2] = useState(false); //상관없음 true,false,
    const [latlng, setlatlng] = useState({lat: 33.450701, lng: 126.570667 });   

    const [hp, sethp] = useState(''); //연락처
    const [memo, setmemo] = useState(''); //특이사항
    
    const [citys, setcitys] = useState([]);   
    const [listselecterviewerlist, setlistselecterviewerlist] = useState([]);   
    const [polylist, setpolylist] = useState([]);   
    const [memberinfos, setmemberinfos] = useState(''); 
    console.log(memberinfos);
    
    useEffect(() => {
        document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'hidden';
        getMemberinfo(setmemberinfos);
        return () => {
            document.getElementsByTagName('HTML')[0]['style']['overflow-y'] = 'scroll';
        }
    }, []);


    useEffect(() => {
        if(row?.idx){
            setsell_type(row?.sell_type);
            setcategory_1(row?.category_1);
            setcategory_2(row?.category_2);
            console.log(row);
            settitle(row?.title);
            let donglist = [];
            let polylists = [];
            row?.citys?.map((x, i) => {
                if(x?.polygon !== null){
                    let addDatas = {
                        coordinate: 'wgs84', 
                        options: {strokeColor: '#39f', strokeWeight: 3, strokeStyle: 'solid', strokeOpacity: 1, fillColor: '#39f', fillOpacity: 0.5, },
                        points: JSON.parse(x?.polygon),
                        type: 'polygon'
                    }
                    polylists.push(addDatas);
                } else {
                    donglist.push({ sido: x?.sido, sigungu: x?.sigungu, viewernames: x?.dong === '전체' ? x?.sigungu+" 전체" : x?.dong });
                }
            });
            setpolylist(polylists);
            setlistselecterviewerlist(donglist);
            setprice_all_min(row?.price_all_min);
            setprice_all_max(row?.price_all_max);
            setprice_month_min(row?.price_month_min);
            setprice_month_max(row?.price_month_max);
            setprice_key_min(row?.price_key_min);
            setprice_key_max(row?.price_key_max);
            setprice_real(row?.price_real);
            setitem_floor_min(row?.item_floor_min);
            setitem_floor_max(row?.item_floor_max);
            setitem_area_min(row?.item_area_min);
            setitem_area_max(row?.item_area_max);
            setitem_year_min(row?.item_year_min);
            setitem_year_max(row?.item_year_max);
            setin_year(row?.in_year);
            setin_year_option1(row?.in_year_option1);
            sestin_year_option2(row?.in_year_option2);
            let checkvaluesData = [];
            if(row?.in_year_option1 === true){
                checkvaluesData.push({names: '협의가능', values: 0});
            }
            if(row?.in_year_option2 === true){
                checkvaluesData.push({names: '협의가능', values: 1});
            }
            setcheckvalues(checkvaluesData);

            sethp(row?.hp);
            setmemo(row?.memo);

        }
    }, [row]);

    useEffect(() => {
        seterrmsg('');
        console.log(listselecterviewerlist);
    }, [
        title, sell_type, category_1, category_2, price_all_min, price_all_max, price_month_min, price_month_max, price_key_min, price_key_max, 
        price_real, item_floor_min, item_floor_max, item_area_min, item_area_max, item_year_min, item_year_max, in_year, hp,
        memo, citys, listselecterviewerlist, polylist
    ]);

    const selectOverlay = (type) => {
        const manager = managerRef.current
        console.log(manager);
        manager.cancel()
        manager.select(type)
    }
    const drawOverlayData = (datas) => {
        const manager = managerRef.current;
        //console.log(manager.getData());
        console.log(datas);
        setpolylist([...polylist, ...datas]);
    }
    const pointsToPath = (points) => {
        return points.map((point) => ({
            lat: point.y,
            lng: point.x,
        }))
    }
    const customerWirteSubmit = (uidx=null) => {

        // title, sell_type, category_1, category_2, price_all_min, price_all_max, price_month_min, price_month_max, price_key_min, price_key_max, 
        // price_real, item_floor_min, item_floor_max, item_area_min, item_area_max, item_year_min, item_year_max, in_year, hp,
        // memo, citys, listselecterviewerlist, polylist

        let citysArr = [];
        listselecterviewerlist?.map((x, i) => {
            //console.log(item, x?.viewernames, x?.viewernames?.includes('전체'));
            if(x?.viewernames?.includes('전체')){
                citysArr.push({type: 1, sido: x?.sido, sigungu: x?.sigungu, dong: '전체' });
            } else {
                citysArr.push({type: 1, sido: x?.sido, sigungu: x?.sigungu, dong: x?.viewernames });
            }
        });
        polylist?.map((x, i) => {
            citysArr.push({type: 2, sido: '', sigungu: '', dong: '', polygon: JSON.stringify(x?.points) });
        });

        //console.log(citysArr);

        let inputsdefaultsArr= [
            {values: title, comments: '고객명칭을', comment_types: '입력'},
            {values: sell_type, comments: '거래형태를', comment_types: '선택'},
            {values: category_1, comments: '매물종류를', comment_types: '선택'},
            {values: category_2, comments: '하위매물종류를', comment_types: '선택'},
            {values: citysArr?.length < 1 ? '' : citysArr?.length, comments: '희망지역을', comment_types: '선택'},
            sell_type === '매매' && {values: price_all_min, comments: '희망매매가 최소금액을', comment_types: '입력'},
            sell_type === '매매' && {values: price_all_max, comments: '희망매매가 최대금액을', comment_types: '입력'},
            sell_type !== '매매' && {values: price_all_min, comments: '희망보증금 최소금액을', comment_types: '입력'},
            sell_type !== '매매' && {values: price_all_max, comments: '희망보증금 최대금액을', comment_types: '입력'},
            sell_type === '월세' && {values: price_month_min, comments: '희망월세 최소금액을', comment_types: '입력'},
            sell_type === '월세' && {values: price_month_max, comments: '희망월세 최대금액을', comment_types: '입력'},
            //{values: in_year, comments: '입주시기를', comment_types: '선택'},
            {values: hp, comments: '연락처를', comment_types: '입력'},
        ];
        for(let c = 0; c < inputsdefaultsArr?.length; c++){
            if(inputsdefaultsArr[c]?.values === ''){
                seterrmsg(`${inputsdefaultsArr[c]?.comments} ${inputsdefaultsArr[c]?.comment_types}해주세요.`);
                return;
            }
        }

        let sender = {
            idx: uidx,
            miniIdx: stypes === "미니홈고객의뢰" ? row?.idx : 0,
            bpmIdx: stypes === "발품맨 고객의뢰" ? row?.idx : 0,
            title: title,
            sell_type: sell_type,
            category_1: category_1,
            category_2: category_2,
            price_all_min: price_all_min*1,
            price_all_max: price_all_max*1,
            price_month_min: price_month_min*1,
            price_month_max: price_month_max*1,
            price_key_min: price_key_min*1,
            price_key_max: price_key_max*1,
            price_real: price_real*1,
            item_floor_min: item_floor_min*1,
            item_floor_max: item_floor_max*1,
            item_area_min: item_area_min,
            item_area_max: item_area_max,
            item_year_min: item_year_min*1,
            item_year_max: item_year_max*1,
            in_year: in_year,
            in_year_option1: checkvalues?.filter(item => item?.values*1 === 0)?.length > 0 ? true : false,
            in_year_option2: checkvalues?.filter(item => item?.values*1 === 1)?.length > 0 ? true : false,
            hp: hp,
            memo: memo,
            citys: citysArr,
        }

        //console.log(sender);
        //return;
        dispatch(
            open({
                component: `${uidx !== null ? '수정' : '등록'}하시겠습니까?`,
                title: '알림',
                button: "등록",
                buttonCencle: "취소",       
                titleviewer: true,                 
                alert: false,
                onPress: () => {
                    dispatch(loadingflas({ loading: true }));
                    APIS.postData('/v1/customer/insert', sender).then(({ data }) => {
                        if(data){
                            dispatch(close());
                            setcustomerwirte(false);
                            setdetailwrite(false);
                            setupdatestatus(true);
                            dispatch(listupdater({ listupdate: true }));
                            dispatch(
                                open({
                                    component: `고객이 ${uidx !== null ? '수정' : '등록'}되었습니다.`,
                                    title: '알림',
                                    titleviewer: true,
                                    alert: false,
                                    button: "확인",
                                    onPress: () => {
                                        setselltypeproduct(sell_type);
                                        setcategory_1product(category_1*1);
                                        setcategory_2product(category_2*1);                                        
                                        dispatch(close());
                                    }
                                })
                            );   
                        }
                    }).catch(({ response }) => {
                        const { data } = response;
                        console.log(response);
                        dispatch(
                            open({
                                component: data?.msg ? data?.msg : '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                title: '알림',
                                button: "확인",
                                titleviewer: true,                 
                                alert: false,
                                onPress: () => {
                                    dispatch(close());
                                },
                            })
                        );   
                    }).finally(() => {
                        dispatch(loadingflas({ loading: false }));
                    });     
                },
                onCancelPress: () => {
                    dispatch(close());
                }
            })
        );   

    }
    return (
        <>
            <div className='ProductDetailArea' style={{ zIndex: 1003 }}>
                <div>
                    <div className='ProductDetailAreaBG' 
                        // onClick={() => {
                        //     setdetailwrite(false);
                        // }}
                    />

                    <div></div>
                    <div className="ProductSendDetailpop"> 
                        <div className="ProductpopTitle padding20" style={{ borderBottom: '1px solid #eee'}}>
                            <span>고객등록</span>
                            <button
                                onClick={() => {
                                    setdetailwrite(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" />                                            
                            </button>
                        </div>
                        <div className="productInputarea padding32" >
                            <div className="inputviewtype1 " style={{ marginTop: 0 }}>
                                <div>고객명칭<span className='colorF00'>*</span></div>
                                <div>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={settitle}
                                        value={title}
                                        name="mb_phone"
                                    />  
                                </div>
                            </div>                             
                            <div className="inputviewtype1 " >
                                <div>거래형태<span className='colorF00'>*</span></div>
                                <div>
                                    {category_2*1 !== 3 && 
                                    <Button buttonTxt={'매매'} className={`writeRadiobutton ${sell_type === '매매' ? 'active' : ''}`} onPress={() => {
                                        // if(category_2*1 === 3){
                                        //     return;
                                        // }
                                        setsell_type('매매') 
                                    }} />}
                                    <Button buttonTxt={'전세'} className={`writeRadiobutton ${sell_type === '전세' ? 'active' : ''}`} onPress={() => setsell_type('전세') } />
                                    <Button buttonTxt={'월세'} className={`writeRadiobutton ${sell_type === '월세' ? 'active' : ''}`} onPress={() => setsell_type('월세') } />
                                    {category_2*1 === 3 && 
                                        <div className="input_error">* 단독/다가구 매매는 건물-주거전용건물 탭을 이용하세요.</div>
                                    }
                                </div>
                            </div>
                                                        
                            <div className="inputviewtype4 " style={{ alignItems: 'flex-start' }}>
                                <div style={{ marginTop: 0 }}>매물 종류<span className='colorF00'>*</span></div>
                                <div>
                                    <div>
                                        <Radios
                                            linetype={'radioimg'}
                                            values={category_1}
                                            setvalues={(e) => {
                                                setcategory_1(e*1);
                                                setcategory_2(category_2_setting?.filter((x2, i2) => (x2.category_1*1 === e*1))[0]?.values);
                                            }} 
                                            namevalue={category_1_OptionConsts}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        />
                                    </div>
                                    <div className='margint8'>
                                        <Select 
                                            styles={{}}
                                            setValues={(e) => {
                                                // if(e*1 === 3){
                                                //     setsell_type('전세');
                                                // }
                                                if(sell_type === '매매' && e*1 === 3){
                                                    setsell_type('전세');
                                                }

                                                setcategory_2(e);
                                            }}
                                            values={category_2}
                                            selectData={category_2_setting?.filter((x, i) => x?.category_1*1 === category_1*1)}
                                        /> 
                                    </div>
                                </div>
                            </div>       

                            <div className="inputviewtype4 " style={{ alignItems: 'flex-start'}}>
                                <div>희망 지역<span className='colorF00'>*</span></div>
                                <div>
                                    <div style={{ gap: 8 }}>
                                        <Button
                                            buttonTxt={'목록으로 선택'}
                                            className={'linenormalbutton'}
                                            onPress={() => {
                                                setcityspopflag(true);
                                            }}                             
                                            styles={{
                                                width: 100, height: 36, borderRadius: 0,
                                                fontSize: 14
                                            }}
                                        />
                                        <Button
                                            buttonTxt={'지도로 선택'}
                                            className={'linenormalbutton'}
                                            onPress={() => {
                                                setpolygonpopflag(true);
                                                let address = memberinfos?.compony?.addr;
                                                const geocoder = new window.kakao.maps.services.Geocoder();
                                                geocoder.addressSearch(address, function (result, status) {
                                                  if (status === window.kakao.maps.services.Status.OK) {
                                                    const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);
                                                    //console.log(result[0].y, result[0].x);
                                                    setlatlng({lat: result[0].y, lng: result[0].x });
                                                  }
                                                });

                                            }}                             
                                            styles={{
                                                width: 100, height: 36, borderRadius: 0,
                                                fontSize: 14
                                            }}
                                        />
                                    </div>
                                    {(listselecterviewerlist?.length > 0 || polylist?.length > 0) &&
                                    <div className='margint8'>
                                        <div className='selstickdelarea ' style={{ width: '100%' }}>
                                            {listselecterviewerlist?.length > 0 && listselecterviewerlist?.map((x, i) => {
                                                return (
                                                    <button 
                                                        type="button" key={i}
                                                        onClick={() => {
                                                            setlistselecterviewerlist(listselecterviewerlist?.filter(item => item?.viewernames !== x?.viewernames));  
                                                        }}
                                                    >
                                                        {x?.viewernames}
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 3.52851C3.78886 3.26816 4.21097 3.26816 4.47132 3.52851L7.99992 7.05711L11.5285 3.52851C11.7889 3.26816 12.211 3.26816 12.4713 3.52851C12.7317 3.78886 12.7317 4.21097 12.4713 4.47132L8.94273 7.99992L12.4713 11.5285C12.7317 11.7889 12.7317 12.211 12.4713 12.4713C12.211 12.7317 11.7889 12.7317 11.5285 12.4713L7.99992 8.94273L4.47132 12.4713C4.21097 12.7317 3.78886 12.7317 3.52851 12.4713C3.26816 12.211 3.26816 11.7889 3.52851 11.5285L7.05711 7.99992L3.52851 4.47132C3.26816 4.21097 3.26816 3.78886 3.52851 3.52851Z" fill="#999999"/>
                                                        </svg>                                
                                                    </button>
                                                );
                                            })}
                                            {polylist?.length > 0 && polylist?.map((x, i) => {
                                                return (
                                                    <button 
                                                        type="button" key={i}
                                                        onClick={() => {
                                                            setpolylist(polylist?.filter((item, index) => index !== i));  
                                                        }}
                                                    >
                                                        폴리곤{i+1}
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 3.52851C3.78886 3.26816 4.21097 3.26816 4.47132 3.52851L7.99992 7.05711L11.5285 3.52851C11.7889 3.26816 12.211 3.26816 12.4713 3.52851C12.7317 3.78886 12.7317 4.21097 12.4713 4.47132L8.94273 7.99992L12.4713 11.5285C12.7317 11.7889 12.7317 12.211 12.4713 12.4713C12.211 12.7317 11.7889 12.7317 11.5285 12.4713L7.99992 8.94273L4.47132 12.4713C4.21097 12.7317 3.78886 12.7317 3.52851 12.4713C3.26816 12.211 3.26816 11.7889 3.52851 11.5285L7.05711 7.99992L3.52851 4.47132C3.26816 4.21097 3.26816 3.78886 3.52851 3.52851Z" fill="#999999"/>
                                                        </svg>                                
                                                    </button>
                                                );
                                            })}                                            
                                            
                                        </div>  
                                    </div>
                                    }
                                </div>
                            </div>   

                            <div className="inputviewtype1 ">
                                <div>{sell_type === '매매' ? '희망매매가' : '희망보증금'}<span className='colorF00'>*</span></div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                        <Input 
                                            className={`inputs`}
                                            type={'number'}
                                            rightplaceholder="만원"
                                            placeholder=""
                                            setValue={setprice_all_min}
                                            value={price_all_min}
                                            name="mb_phone"
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 40, textAlign: 'right'
                                            }}
                                        />                                      
                                    </div>
                                    <span>~</span>
                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                        <Input 
                                            className={`inputs`}
                                            type={'number'}
                                            rightplaceholder="만원"
                                            placeholder=""
                                            setValue={setprice_all_max}
                                            value={price_all_max}
                                            name="mb_phone"
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 40, textAlign: 'right'
                                            }}
                                        />                                        
                                    </div>
                                </div>
                            </div>          
                            {sell_type === '월세' &&
                            <div className="inputviewtype1 ">
                                <div>희망월세<span className='colorF00'>*</span></div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                        <Input 
                                            className={`inputs`}
                                            rightplaceholder="만원"
                                            type={'number'}
                                            placeholder=""
                                            setValue={setprice_month_min}
                                            value={price_month_min}
                                            name="mb_phone"
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 40, textAlign: 'right'
                                            }}
                                        />                                      
                                    </div>
                                    <span>~</span>
                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                        <Input 
                                            className={`inputs`}
                                            rightplaceholder="만원"
                                            type={'number'}
                                            placeholder=""
                                            setValue={setprice_month_max}
                                            value={price_month_max}
                                            name="mb_phone"
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 40, textAlign: 'right'
                                            }}
                                        />                                        
                                    </div>
                                </div>
                            </div>     
                            }
                            {( (sell_type === '매매' && (category_2*1 === 5 || category_2*1 === 6 || category_2*1 === 7 || category_2*1 === 8)) || 
                            (sell_type !== '매매' && (category_2*1 === 5 || category_2*1 === 6 || category_2*1 === 7 || category_2*1 === 8 || category_2*1 === 9)) ) &&
                            <div className="inputviewtype1 ">
                                <div>권리금</div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                        <Input 
                                            className={`inputs`}
                                            type={'number'}
                                            rightplaceholder="만원"
                                            placeholder=""
                                            setValue={setprice_key_min}
                                            value={price_key_min}
                                            name="mb_phone"
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 40, textAlign: 'right'
                                            }}
                                        />                                      
                                    </div>
                                    <span>~</span>
                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                        <Input 
                                            className={`inputs`}
                                            type={'number'}
                                            rightplaceholder="만원"
                                            placeholder=""
                                            setValue={setprice_key_max}
                                            value={price_key_max}
                                            name="mb_phone"
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 40, textAlign: 'right'
                                            }}
                                        />                                        
                                    </div>
                                </div>
                            </div>      
                            }
                            <div className='margint12 color666'>
                                거래에 필요한 실제 금액을 입력하시면 매칭에 도움이 됩니다.<br />
                                매매: 매매가-현보증금 / 임대: 보증금 (+권리금)
                            </div>                       
                               
                            <div className="inputviewtype1 ">
                                <div>실투자금</div>
                                <div>
                                    <Input 
                                        className={`inputs`}
                                        type={'number'}
                                        rightplaceholder="만원"
                                        placeholder=""
                                        setValue={setprice_real}
                                        value={price_real}
                                        name="mb_phone"
                                        zerostatus={true}
                                        style={{
                                            paddingRight: 40, textAlign: 'right'
                                        }}
                                    />  
                                </div>
                            </div>      
                            <div className="inputviewtype1 ">
                                <div>희망 층수</div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                        <Input 
                                            className={`inputs`}
                                            type={'number'}
                                            rightplaceholder="층"
                                            placeholder=""
                                            setValue={setitem_floor_min}
                                            value={item_floor_min}
                                            name="mb_phone"
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 30, textAlign: 'right'
                                            }}
                                        />                                      
                                    </div>
                                    <span>~</span>
                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                        <Input 
                                            className={`inputs`}
                                            type={'number'}
                                            rightplaceholder="층"
                                            placeholder=""
                                            setValue={setitem_floor_max}
                                            value={item_floor_max}
                                            name="mb_phone"
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 30, textAlign: 'right'
                                            }}
                                        />                                        
                                    </div>
                                </div>
                            </div> 
                            <div className="inputviewtype1 ">
                                <div>희망 면적</div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                        <Input 
                                            className={`inputs`}
                                            type={'number'}
                                            rightplaceholder="㎡"
                                            placeholder=""
                                            setValue={setitem_area_min}
                                            value={item_area_min}
                                            name="mb_phone"
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 34, textAlign: 'right'
                                            }}
                                        />                                      
                                    </div>
                                    <span>~</span>
                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                        <Input 
                                            className={`inputs`}
                                            type={'number'}
                                            rightplaceholder="㎡"
                                            placeholder=""
                                            setValue={setitem_area_max}
                                            value={item_area_max}
                                            name="mb_phone"
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 34, textAlign: 'right'
                                            }}
                                        />                                        
                                    </div>
                                </div>
                            </div> 
                            <div className="inputviewtype1 ">
                                <div>희망 연식</div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                        <Input 
                                            className={`inputs`}
                                            rightplaceholder="년"
                                            placeholder="yyyy"
                                            setValue={setitem_year_min}
                                            value={item_year_min}
                                            onBlur={() => {
                                                if(item_year_min?.length < 4){
                                                    setdateerrmsg('희망연식을 확인해주세요.');
                                                    return;
                                                }

                                                let dates = `${item_year_min}-01-01`;
                                                if(moment(dates).format('YYYY') === 'Invalid date'){
                                                    setdateerrmsg('희망연식을 확인해주세요.');
                                                } else {
                                                    setdateerrmsg('');
                                                    setitem_year_min(moment(dates).format('YYYY'));
                                                }
                                            }}

                                            name="mb_phone"
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 30, textAlign: 'right'
                                            }}
                                        />        
                                        {dateerrmsg !== '' && <div className='err' style={{ color: 'red' }}>{dateerrmsg}</div>}
                                    </div>
                                    <span>~</span>
                                    <div style={{ width: 'calc(50% - 10px)' }}>
                                        <Input 
                                            className={`inputs`}
                                            rightplaceholder="년"
                                            placeholder="yyyy"
                                            setValue={setitem_year_max}
                                            value={item_year_max}
                                            onBlur={() => {
                                                if(item_year_max?.length < 4){
                                                    setdateerrmsg('희망연식을 확인해주세요.');
                                                    return;
                                                }
                                                let dates = `${item_year_max}-01-01`;
                                                if(moment(dates).format('YYYY') === 'Invalid date'){
                                                    setdateerrmsg('희망연식을 확인해주세요.');
                                                } else {
                                                    setdateerrmsg('');
                                                    setitem_year_max(moment(dates).format('YYYY'));
                                                }
                                            }}                    
                                            maxlength={4}                        
                                            name="mb_phone"
                                            zerostatus={true}
                                            style={{
                                                paddingRight: 30, textAlign: 'right'
                                            }}
                                        />      
                                        {dateerrmsg !== '' && <div className='err' style={{ color: '#fff'}}>asdfasdf</div>}
                                    </div>
                                </div>
                                
                            </div> 
                            
                            <div className="inputviewtype2 ">
                                <div>입주시기<span className='colorF00'>*</span></div>
                                <div>
                                    <div style={{ width: '100%' }}>
                                        <div style={{ width: '100%' }}>
                                            <InputDate 
                                                type="text" placeholder="yymmdd" name="ipd1" 
                                                dateValue={in_year} 
                                                setDateValue={setin_year} 
                                            />
                                        </div>
                                    </div>         
                                    <div>
                                        <Checkbox
                                            linetype={'checkimg'}
                                            values={checkvalues}
                                            setvalues={setcheckvalues}
                                            namevalue={[
                                                {names: '협의가능', values: 0},
                                                {names: '상관없음', values: 1},
                                            ]}
                                            fontweights={400}
                                            fontSizes={14}
                                            sizes={20}
                                        />  
                                    </div>                                      
                                </div>
                            </div>
                            
                            <div className="inputviewtype1 ">
                                <div>연락처<span className='colorF00'>*</span></div>
                                <div>
                                    <Input 
                                        className={`inputs`}
                                        placeholder=""
                                        setValue={sethp}
                                        value={hp}
                                        name="customerhp"
                                    />  
                                </div>
                            </div>   
                             
                            <div className="inputviewtype1 ">
                                <div>특이사항</div>
                                <div>
                                    <textarea 
                                        placeholder='고객의 추가적인 요구 조건을 입력하시면 미팅에 큰 도움이 됩니다. 매칭에 적용되는 칸은 아닙니다.'
                                        onChange={(e) => {
                                            setmemo(e.target.value);
                                        }}
                                        value={memo}
                                    />                                    
                                </div>
                            </div>          
                            <div 
                                style={{ height: 1, backgroundColor: '#EEE', marginTop: 20}}
                            />    
                            <div className="input_error">{errmsg}</div>
                            <div style={{ textAlign: 'center', marginTop: 20 }}>미입력 된 항목은 전체 범위로 [A.I 매칭] 됩니다.</div>
                            <div 
                                className='margint20'
                                style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                                }}
                            >
                                <div style={{ width: '50%' }}>
                                    <Button
                                        buttonTxt={'취소'}
                                        disabled={true} 
                                        onPress={() => { 
                                            setdetailwrite(false);                                    
                                        }}
                                    />                                       
                                </div>
                                <div style={{ width: '50%'}}>
                                    <Button
                                        buttonTxt={'등록'}
                                        styles={{ 
                                        }} 
                                        onPress={() => { 
                                            //customerWirteSubmit();   
                                            customerWirteSubmit(uidx, false);      
                                        }}
                                    />     
                                </div>                            
                            </div>                                              
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
            {cityspopflag === true &&
            <div className='PopupArea'>
                <div>
                    <div className='PopupAreaBG' 
                        //onClick={() => { setcityspopflag(false); }}
                    />
                    <div className='PopupAreaContents' style={{ width: 800}}>
                        <div>
                            <div className="popTitle padding20">
                                <span >희망지역</span>
                                <button
                                    onClick={() => {
                                        setcityspopflag(false);
                                    }}
                                >
                                    <img src="./images/icons/x.svg" width='20' />                                            
                                </button>
                            </div>
                            <div className="padding32">
                                <div className='popcontents'>
                                    <div style={{ width: '100%' }}>
                                        <div>
                                            <div className="filteraddrarea">
                                                <AddrSelector
                                                    setcityspopflag={setcityspopflag}
                                                    listselecterviewerlist={listselecterviewerlist}
                                                    setlistselecterviewerlist={setlistselecterviewerlist}
                                                />                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='selstickdelarea margint20' >
                                    {listselecterviewerlist?.length > 0 && listselecterviewerlist?.map((x, i) => {
                                        return (
                                            <button 
                                                type="button" key={i}
                                                onClick={() => {
                                                    setlistselecterviewerlist(listselecterviewerlist?.filter(item => item?.viewernames !== x?.viewernames));  
                                                }}
                                            >
                                                {x?.viewernames}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 3.52851C3.78886 3.26816 4.21097 3.26816 4.47132 3.52851L7.99992 7.05711L11.5285 3.52851C11.7889 3.26816 12.211 3.26816 12.4713 3.52851C12.7317 3.78886 12.7317 4.21097 12.4713 4.47132L8.94273 7.99992L12.4713 11.5285C12.7317 11.7889 12.7317 12.211 12.4713 12.4713C12.211 12.7317 11.7889 12.7317 11.5285 12.4713L7.99992 8.94273L4.47132 12.4713C4.21097 12.7317 3.78886 12.7317 3.52851 12.4713C3.26816 12.211 3.26816 11.7889 3.52851 11.5285L7.05711 7.99992L3.52851 4.47132C3.26816 4.21097 3.26816 3.78886 3.52851 3.52851Z" fill="#999999"/>
                                                </svg>                                
                                            </button>
                                        );
                                    })}
                                </div>                                   
                                <div className="filterlines" style={{ margin: 0, marginTop: 20 }}></div>
                                <div className='popbuttons'>
                                    <div style={{ width: '70%'}}>
                                        <Button
                                            buttonTxt={'등록하기'}
                                            onPress={() => { 
                                                setcityspopflag(false);
                                            }}
                                        />    
                                    </div>
                                    <div style={{ width: '30%'}}>
                                        <Button
                                            className={'linenormalbutton'}
                                            buttonTxt={'초기화'}
                                            titleimgs={`./images/icons/loop-left-line-purple.svg`}
                                            onPress={() => { 
                                                setlistselecterviewerlist([]);
                                            }}
                                        />                                                                           
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            }

            {polygonpopflag === true &&
            <div className='PopupArea'>
                <div>
                    <div className='PopupAreaBG' 
                        //onClick={() => { setpolygonpopflag(false); }}
                    />
                    <div className='PopupAreaContents' style={{ width: 800}}>
                        <div>
                            <div className="popTitle padding20">
                                <span >희망지역</span>
                                <button
                                    onClick={() => {
                                        setpolygonpopflag(false);
                                    }}
                                >
                                    <img src="./images/icons/x.svg" width='20' />                                            
                                </button>
                            </div>
                            <div className="padding32">
                                <div className='popcontents'>
                                    <div style={{ width: '100%' }}>
                                        <div>
                                            <div className="filteraddrarea">
                                                <Map // 지도를 표시할 Container
                                                    id="map"
                                                    center={latlng}
                                                    style={{
                                                        // 지도의 크기
                                                        width: "100%",
                                                        height: 400,
                                                    }}
                                                    level={3} // 지도의 확대 레벨
                                                >                
                                                    {polylist.map(({ options, points }, i) => (
                                                        <Polygon key={i} path={pointsToPath(points)} {...options} />
                                                    ))}
                                                    <DrawingManager
                                                        ref={managerRef}
                                                        drawingMode={[
                                                            "polygon",
                                                        ]}
                                                        onDrawend={(e) => {
                                                            const manager = managerRef.current
                                                            // e?._eventHandlers.remove = [];
                                                            // var rectangleOverlays = manager.getOverlays();
                                                            // manager.remove(rectangleOverlays);
                                                            //console.log();
                                                            setpolylist([...polylist, ...manager.getData()?.polygon]);

                                                        }}
                                                        onRemove={(e) => {
                                                            //drawOverlayData();
                                                            const manager = managerRef.current
                                                            manager.cancel();
                                                        }}
                                                        
                                                        guideTooltip={["draw", "drag", "edit"]}
                                                        polygonOptions={{
                                                            draggable: true,
                                                            editable: true,
                                                            removable: true,
                                                            strokeColor: "#39f",
                                                            fillColor: "#39f",
                                                            fillOpacity: 0.5,
                                                            hintStrokeStyle: "dash",
                                                            hintStrokeOpacity: 0.5,
                                                        }}
                                                        arrowOptions={{
                                                            draggable: true, // 그린 후 드래그가 가능하도록 설정합니다
                                                            removable: true, // 그린 후 삭제 할 수 있도록 x 버튼이 표시됩니다
                                                            editable: true, // 그린 후 수정할 수 있도록 설정합니다
                                                            strokeColor: "#39f", // 선 색
                                                            hintStrokeStyle: "dash", // 그리중 마우스를 따라다니는 보조선의 선 스타일
                                                            hintStrokeOpacity: 0.5, // 그리중 마우스를 따라다니는 보조선의 투명도
                                                        }}
                                                        ellipseOptions={{
                                                            draggable: true,
                                                            removable: true,
                                                            editable: true,
                                                            strokeColor: "#39f",
                                                            fillColor: "#39f",
                                                            fillOpacity: 0.5,
                                                        }}
                                                    />        
                                                </Map>                                       
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='selstickdelarea margint20'>
                                    {polylist?.length > 0 && polylist?.map((x, i) => {
                                        return (
                                            <button 
                                                type="button" key={i}
                                                onClick={() => {
                                                    setpolylist(polylist?.filter((item, index) => index !== i));  
                                                }}
                                            >
                                                폴리곤{i+1}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 3.52851C3.78886 3.26816 4.21097 3.26816 4.47132 3.52851L7.99992 7.05711L11.5285 3.52851C11.7889 3.26816 12.211 3.26816 12.4713 3.52851C12.7317 3.78886 12.7317 4.21097 12.4713 4.47132L8.94273 7.99992L12.4713 11.5285C12.7317 11.7889 12.7317 12.211 12.4713 12.4713C12.211 12.7317 11.7889 12.7317 11.5285 12.4713L7.99992 8.94273L4.47132 12.4713C4.21097 12.7317 3.78886 12.7317 3.52851 12.4713C3.26816 12.211 3.26816 11.7889 3.52851 11.5285L7.05711 7.99992L3.52851 4.47132C3.26816 4.21097 3.26816 3.78886 3.52851 3.52851Z" fill="#999999"/>
                                                </svg>                                                  
                                            </button>
                                        );
                                    })}
                                </div>                                   
                                <div className="filterlines" style={{ margin: 0, marginTop: 20 }}></div>
                                <div 
                                    className='popbuttons'
                                    style={{
                                        justifyContent: 'space-between'
                                    }}
                                >
                                    {polydrawstatus === true ?
                                    <div style={{ width: '100%'}}>
                                        <Button
                                            buttonTxt={'적용하기'}
                                            onPress={() => { 
                                                setpolydrawstatus(false);
                                                const manager = managerRef.current
                                                manager.cancel();        
                                                
                                                var savepolygon = manager.getOverlays()?.polygon;
                                                var rectangleOverlays = manager.getOverlays()?.polygon;
                                                   
                                                rectangleOverlays?.map((x, i) => {
                                                    manager.remove(rectangleOverlays[i]);    
                                                });
                                                drawOverlayData(savepolygon);
                                            }}
                                        />                       
                                    </div>                                    
                                    :
                                    <>
                                    <div style={{ width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8}}>
                                        <Button
                                            buttonTxt={'등록하기'}
                                            onPress={() => { 
                                                setpolygonpopflag(false);
                                            }}
                                        />    
                                        <Button
                                            className={'linenormalbutton'}
                                            buttonTxt={'초기화'}
                                            titleimgs={`./images/icons/loop-left-line-purple.svg`}
                                            onPress={() => { 
                                                setpolylist([]);
                                            }}
                                        />      
                                    </div>
                                    <div style={{ width: '20%'}}>
                                        <Button
                                            buttonTxt={'그리기'}
                                            onPress={() => { 
                                                setpolydrawstatus(true);
                                                selectOverlay(kakao.maps.drawing.OverlayType.POLYGON)
                                            }}
                                        />                       
                                    </div>
                                    </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            }

        </>
    )    
}